import * as Yup from 'yup';
import { maxPoints } from './_constant';

const scoreSchema = Yup.object({
  scoreTarget: Yup.number()
    .nullable()
    .min(0, 'formControl.specializeReview.minScore')
    .when('researchTypeCode', {
      is: (value) => value,
      then: Yup.number().test({
        name: 'checkScoreTarget',
        message: 'formControl.validation.checkReviewPoint',
        test: (value, context) => {
          if (!value) {
            return true;
          }
          const { researchTypeCode } = context.parent;
          const { scoreTarget } = maxPoints[researchTypeCode];
          if (parseInt(value, 10) < 0 || parseInt(value, 10) > scoreTarget) return false;
          return true;
        },
      }),
    }),

  scoreContent: Yup.number()
    .nullable()
    .min(0, 'formControl.specializeReview.minScore')
    .when('researchTypeCode', {
      is: (value) => value,
      then: Yup.number().test({
        name: 'checkScoreContent',
        message: 'formControl.validation.checkReviewPoint',
        test: (value, context) => {
          if (!value) {
            return true;
          }
          const { researchTypeCode } = context.parent;
          const { scoreContent } = maxPoints[researchTypeCode];
          if (parseInt(value, 10) < 0 || parseInt(value, 10) > scoreContent) return false;
          return true;
        },
      }),
    }),

  scoreApproach: Yup.number()
    .nullable()
    .min(0, 'formControl.specializeReview.minScore')
    .when('researchTypeCode', {
      is: (value) => value,
      then: Yup.number().test({
        name: 'checkScoreApproach',
        message: 'formControl.validation.checkReviewPoint',
        test: (value, context) => {
          if (!value) {
            return true;
          }
          const { researchTypeCode } = context.parent;
          const { scoreApproach } = maxPoints[researchTypeCode];
          if (parseInt(value, 10) < 0 || parseInt(value, 10) > scoreApproach) return false;
          return true;
        },
      }),
    }),

  scoreProcess: Yup.number()
    .nullable()
    .min(0, 'formControl.specializeReview.minScore')
    .when('researchTypeCode', {
      is: (value) => value,
      then: Yup.number().test({
        name: 'checkScoreProcess',
        message: 'formControl.validation.checkReviewPoint',
        test: (value, context) => {
          if (!value) {
            return true;
          }
          const { researchTypeCode } = context.parent;
          const { scoreProcess } = maxPoints[researchTypeCode];
          if (parseInt(value, 10) < 0 || parseInt(value, 10) > scoreProcess) return false;
          return true;
        },
      }),
    }),

  scoreApplicationProduct: Yup.number()
    .nullable()
    .min(0, 'formControl.specializeReview.minScore')
    .when('researchTypeCode', {
      is: (value) => value,
      then: Yup.number().test({
        name: 'checkScoreApplicationProduct',
        message: 'formControl.validation.checkReviewPoint',
        test: (value, context) => {
          if (!value) {
            return true;
          }
          const { researchTypeCode } = context.parent;
          const { scoreApplicationProduct } = maxPoints[researchTypeCode];
          if (parseInt(value, 10) < 0 || parseInt(value, 10) > scoreApplicationProduct)
            return false;
          return true;
        },
      }),
    }),

  scorePublishedProduct: Yup.number()
    .nullable()
    .min(0, 'formControl.specializeReview.minScore')
    .when('researchTypeCode', {
      is: (value) => value,
      then: Yup.number().test({
        name: 'checkScorePublishedProduct',
        message: 'formControl.validation.checkReviewPoint',
        test: (value, context) => {
          if (!value) {
            return true;
          }
          const { researchTypeCode } = context.parent;
          const { scorePublishedProduct } = maxPoints[researchTypeCode];
          if (parseInt(value, 10) < 0 || parseInt(value, 10) > scorePublishedProduct) return false;
          return true;
        },
      }),
    }),

  scoreTrainingProduct: Yup.number()
    .nullable()
    .min(0, 'formControl.specializeReview.minScore')
    .when('researchTypeCode', {
      is: (value) => value,
      then: Yup.number().test({
        name: 'checkScoreTrainingProduct',
        message: 'formControl.validation.checkReviewPoint',
        test: (value, context) => {
          if (!value) {
            return true;
          }
          const { researchTypeCode } = context.parent;
          const { scoreTrainingProduct } = maxPoints[researchTypeCode];
          if (parseInt(value, 10) < 0 || parseInt(value, 10) > scoreTrainingProduct) return false;
          return true;
        },
      }),
    }),

  scoreReportQuality: Yup.number()
    .nullable()
    .min(0, 'formControl.specializeReview.minScore')
    .when('researchTypeCode', {
      is: (value) => value,
      then: Yup.number().test({
        name: 'checkScoreReportQuality',
        message: 'formControl.validation.checkReviewPoint',
        test: (value, context) => {
          if (!value) {
            return true;
          }
          const { researchTypeCode } = context.parent;
          const { scoreReportQuality } = maxPoints[researchTypeCode];
          if (parseInt(value, 10) < 0 || parseInt(value, 10) > scoreReportQuality) return false;
          return true;
        },
      }),
    }),
});

// eslint-disable-next-line import/prefer-default-export
export const createAcceptanceReviewValidationSchema = Yup.object().shape({
  reviewMeet: Yup.string().nullable(),
  reviewProduct: Yup.string().nullable(),
  reviewReportQuality: Yup.string().nullable(),
  // expenditure: expenditureSchema,
  score: scoreSchema,
});
